import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Checkbox, Typography, FormHelperText, FormControlLabel } from '@material-ui/core';
import useTrustService from 'hooks/useTrustService';

const TermButton = ({ formik, id, text, setShowTerm, dataTestid, testButtonid }) => {
  const { trustServiceAgreement } = useTrustService();

  const handleTrustedService = (event) => {
    if (formik.values.trustedServiceAgreement) {
      formik.setFieldValue(id, false);
      trustServiceAgreement(false);
      return;
    }
    formik.setFieldValue(id, event.target.checked);
    trustServiceAgreement(event.target.checked);
  };

  return (
    <Box>
      <Box>
        <FormControlLabel
          style={{ marginRight: 0 }}
          control={
            <Checkbox
              color="primary"
              id={id}
              name={id}
              checked={formik.values.trustedServiceAgreement}
              inputProps={{
                'data-testid': dataTestid,
              }}
              onClick={handleTrustedService}
            />
          }
          label={
            <Box>
              <Typography variant="caption">Li e aceito os</Typography>
            </Box>
          }
        />

        <Button
          data-testid={testButtonid}
          variant="text"
          color="primary"
          title={`Ver ${text}`}
          onClick={() => setShowTerm(true)}
        >
          <Typography variant="caption" style={{ textDecoration: 'underline' }}>
            {text}.
          </Typography>
        </Button>
      </Box>

      <Box>
        <FormHelperText
          hidden={!formik.touched[id] || !formik.errors[id]}
          error={formik.touched[id] && !!formik.errors[id]}
        >
          {formik.errors.trustedServiceAgreement}
        </FormHelperText>
      </Box>
    </Box>
  );
};

TermButton.propTypes = {
  formik: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  setShowTerm: PropTypes.func.isRequired,
  dataTestid: PropTypes.string,
  testButtonid: PropTypes.string,
};

TermButton.defaultProps = {
  dataTestid: '',
  testButtonid: '',
};

export default TermButton;
